// src/components/LanguageSwitcher.js

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'react-bootstrap'; 

// 🛑 ASSUMPTION: Vous utilisez React-Bootstrap pour le style
// Si non, vous pouvez utiliser un simple bouton ou select HTML.

const LanguageSwitcher = () => {
    // Le hook useTranslation fournit la fonction 'i18n' qui gère le changement de langue
    const { i18n } = useTranslation();

    const changeLanguage = (lng) => {
        // i18n.changeLanguage(lng) met à jour la langue de l'application
        // et recharge les traductions pour tous les composants abonnés
        i18n.changeLanguage(lng);
    };

    const currentLanguage = i18n.language;

    return (
        <Dropdown>
            <Dropdown.Toggle variant="secondary" id="dropdown-basic">
                {/* Affiche le code de la langue actuelle ou un drapeau */}
                {currentLanguage.toUpperCase() === 'FR' ? '🇫🇷 Français' : '🇬🇧 English'}
            </Dropdown.Toggle>

            <Dropdown.Menu>
                {/* Option Français */}
                <Dropdown.Item 
                    onClick={() => changeLanguage('fr')} 
                    active={currentLanguage === 'fr'}
                >
                    🇫🇷 Français
                </Dropdown.Item>
                
                {/* Option Anglais */}
                <Dropdown.Item 
                    onClick={() => changeLanguage('en')} 
                    active={currentLanguage === 'en'}
                >
                    🇬🇧 English
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default LanguageSwitcher;